import { Component, HostListener, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-pwa-install',
  standalone: true,
  imports: [CommonModule, ButtonModule, ToastModule],
  template: `
    <div *ngIf="deferredPrompt" class="pwa-install-banner p-3 shadow-4 border-round flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <img src="assets/img/logo-pwa-dark.png" alt="App Logo" class="mr-3" style="width: 44px; height: 44px; object-fit: contain; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
        <div>
          <span class="font-bold block text-900">Instalar Aplicación</span>
          <small class="text-600">Accede más rápido desde tu escritorio</small>
        </div>
      </div>
      <div class="flex gap-2">
        <p-button label="Ahora no" [text]="true" severity="secondary" (onClick)="deferredPrompt = null" size="small"></p-button>
        <p-button label="Instalar" icon="fas fa-plus" (onClick)="installPwa()" size="small"></p-button>
      </div>
    </div>
    <p-toast position="bottom-right" key="pwa-update">
      <ng-template let-message pTemplate="message">
        <div class="flex flex-column align-items-start gap-2" style="flex: 1">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-sync-alt text-primary font-size-16"></i>
            <span class="font-bold text-900">{{ message.summary }}</span>
          </div>
          <div class="font-medium text-700 font-size-13">{{ message.detail }}</div>
          <div class="pt-1">
            <p-button label="Recargar página" icon="fas fa-redo" size="small" severity="primary" (onClick)="reloadPage()"></p-button>
          </div>
        </div>
      </ng-template>
    </p-toast>
  `,
  styles: [`
    .pwa-install-banner {
      position: fixed;
      bottom: 20px;
      left: 20px;
      right: 20px;
      background: var(--surface-card);
      z-index: 1000;
      border: 1px solid var(--surface-border);
      max-width: 500px;
      margin: 0 auto;
    }
  `],
  providers: [MessageService]
})
export class PwaInstallComponent implements OnInit {
  private swUpdate = inject(SwUpdate);
  private messageService = inject(MessageService);
  deferredPrompt: any;

  ngOnInit() {
    this.checkUpdates();
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(e: Event) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
  }

  installPwa() {
    if (!this.deferredPrompt) return;
    
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the PWA install');
      } else {
        console.log('User dismissed the PWA install');
      }
      this.deferredPrompt = null;
    });
  }

  reloadPage() {
    window.location.reload();
  }

  private checkUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((evt: any): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          this.messageService.add({
            key: 'pwa-update',
            severity: 'info',
            summary: 'Actualización disponible',
            detail: 'Una nueva versión de la aplicación está lista. Haz clic en el botón para recargar la página.',
            sticky: true,
            closable: true,
            id: 'update-toast'
          });
        });
    }
  }
}
